import gql from "graphql-tag";

export default class QueryPlace {
  public static getCartePlaceListing() {
    return gql`
      query getCartePlaceListing($language: String!) {
        getCartePlaceListing(
          defaultLanguage: $language
          sortBy: "name"
          sortOrder: "asc"
        ) {
          edges {
            node {
              id
              name
              position_x
              position_y
              requiredBy {
                id
                name
              }
            }
          }
        }
      }
    `;
  }

  public static getCartePlace() {
    return gql`
      query getCartePlace($language: String!, $id: Int!) {
        getCartePlace(defaultLanguage: $language, id: $id) {
          id
          name
          description
          information
          requiredBy {
            id
            name
          }
          requiredByCitation {
            id
            citation
            description
          }
        }
      }
    `;
  }
}
